import { CommApiInstance } from "Utils/CommApiInstance";

const AppSsoCallBackApi = async (
    referrer:string          ,
    code:string|null         ,
    state:string|null   ,
    gameSvcCd:string|null    ,
    redirectUri:string|null  ,
) => {

        return await CommApiInstance.post(`/athn/login/callback_app/${referrer}`,{
            apiBody:{
                oauth2Tkn:code,
                state:state,
                redirectUri:redirectUri
            },
        })
        .then((Resp) => Resp.data);

}
export default AppSsoCallBackApi;